import React from "react";
import { motion } from "framer-motion";

// Persistent panic pill that lives bottom-left, above the safe-area inset.
// Color forks on Mochi's pronoun: rose for she/her (feminine),
// indigo for he/him (masculine). Pulse is a slow, calming 3s breath
// from 1.0 → 1.04 → 1.0 — never aggressive.
//
// The label is intentionally lowercase, in Mochi's display font, small.
// The intent: small but findable, never the loudest thing on screen.
export default function OverwhelmButton({ onOpen, avatarStyle = "feminine" }) {
    const isFeminine = avatarStyle !== "masculine";
    const tint = isFeminine
        ? "bg-[#E5708A] hover:bg-[#D85F7A] text-white"   // rose
        : "bg-[#6C7EE3] hover:bg-[#5A6DD6] text-white";  // indigo
    return (
        <motion.button
            type="button"
            onClick={onOpen}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0, scale: [1, 1.04, 1] }}
            transition={{
                opacity: { duration: 0.4 },
                y: { duration: 0.4 },
                scale: { duration: 3, repeat: Infinity, ease: "easeInOut" },
            }}
            whileTap={{ scale: 0.96 }}
            className={`fixed z-50 left-3 font-display text-xs px-3 py-1.5 rounded-full shadow-clay ${tint} transition-colors`}
            style={{ bottom: "calc(max(env(safe-area-inset-bottom), 0px) + 84px)" }}
            data-testid="overwhelm-button"
            aria-label="open overwhelm panic flow"
        >
            overwhelmed?
        </motion.button>
    );
}
